// covered-by: frontends/carrie/src/routes/ask-puntt/components/__tests__/ArtworkRegionCitationLink.test.tsx
// covered-by: frontends/carrie/src/routes/ask-puntt/components/__tests__/ChatMessage.test.tsx
import { type ArtworkRegionCitation } from "@mg/schemas/src/commons/ticket";
import { Text } from "@radix-ui/themes";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { PackCitationChip } from "./citation-links/PackCitationChip";

import { groupPackCitations } from "../utils/packCitations";

/** Footer row of pack-artwork chips under an assistant answer, beside the
 * "Cited claims" and web-source rows: one chip per pack, whatever number of
 * its claims the answer cites. Renders nothing without citations. */
export function PackCitationsRow({
  messageId,
  citations,
}: {
  messageId: string;
  citations: ArtworkRegionCitation[];
}) {
  const { t } = useTranslation("ui");
  const packs = useMemo(() => groupPackCitations(citations), [citations]);
  if (packs.length === 0) return null;
  return (
    <div
      className="mt-2 flex flex-wrap items-center gap-2"
      data-testid={`chat-message-pack-citations-${messageId}`}
    >
      <Text
        as="span"
        size="1"
        weight="medium"
        className="text-puntt-neutral-gray-11"
      >
        {t("packCitation.rowTitle")}
      </Text>
      {packs.map((pack) => (
        <PackCitationChip
          key={pack.sourceId}
          pack={pack}
          testIdPrefix={`chat-message-pack-${messageId}-${pack.sourceId}`}
        />
      ))}
    </div>
  );
}
